export const sitemapBase = {
  "top":{"path":"/","name":"トップページ","sub":[]},
  "about":{"path":"/about","name":"月のあかり家族葬について","sub":[]},
  "plan":{"path":"","name":"ご葬儀プラン","sub":[
    {"path":"/plan/?f=flower","name":"花ことば"},
    {"path":"/plan/?f=oneday","name":"一日葬"},
    {"path":"/plan/?f=family","name":"家族葬"},
    {"path":"/plan/?f=funeral","name":"ご葬儀"},
  ]},
  "facilities":{"path":"","name":"式場一覧","sub":[
  ]},
  "facilities-public":{"path":"","name":"公営斎場","sub":[
  ]},
  "before":{"path":"","name":"これからご葬儀を行う方へ","sub":[
    {"path":"/member","name":"会員制度"},
    {"path":"/consultation","name":"事前相談"},
    {"path":"/visitation","name":"ご面会について"},
    {"path":"/donation","name":"寄贈品について"},
    {"path":"/mirai","name":"葬儀信託みらい"},
    {"path":"/payment","name":"お支払いについて"},
  ]},
  "after":{"path":"/after","name":"ご葬儀を終えられた方へ","sub":[]},
  "posts":{"path":"/category/tsuki-akari/","name":"お客様の声 月のあかり通信","sub":[]},
  "company":{"path":"/about/#company","name":"会社概要","sub":[]},
  "privacy":{"path":"/privacypolicy","name":"個人情報保護方針","sub":[]},
  "law":{"path":"/law","name":"特定商取引法に基づく表記","sub":[]},

};